import { Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";
import { Fragment } from "react";
import vintage from "../../images/image32.jpg";
import trouser from "../../images/image2.jpg";
import sneakers from "../../images/image28.jpg";
import gown from "../../images/image15.jpg";
import heels from "../../images/image30.jpg";
import classes from "./categories.module.css";
import Slide from "react-reveal/Slide";

const Categories = () => {
  return (
    <Fragment>
      <Slide bottom>
        <div id="small" className={classes.categories}>
          <Swiper
            slidesPerView={2}
            spaceBetween={30}
            pagination={{
              dynamicBullets: true,
            }}
            modules={[Pagination]}
            className={classes.mySwiper}
          >
            <SwiperSlide>
              <Link to="/gown" className={classes.container}>
                <div className={classes.image}>
                  <img src={gown} />
                </div>
                <h1>Gowns</h1>
              </Link>
            </SwiperSlide>
            <SwiperSlide>
              <Link to="/shirts" className={classes.container}>
                <div className={classes.image}>
                  <img src={vintage} />
                </div>
                <h1>Vintage</h1>
              </Link>
            </SwiperSlide>
            <SwiperSlide>
              <Link to="/trouser" className={classes.container}>
                <div className={classes.image}>
                  <img src={trouser} />
                </div>
                <h1>Trousers</h1>
              </Link>
            </SwiperSlide>
            <SwiperSlide>
              <Link to="/shoes" className={classes.container}>
                <div className={classes.image}>
                  <img src={heels} />
                </div>
                <h1>Heels</h1>
              </Link>
            </SwiperSlide>
            <SwiperSlide>
              <Link to="/shoes" className={classes.container}>
                <div className={classes.image}>
                  <img src={sneakers} />
                </div>
                <h1>Sneakers</h1>
              </Link>
            </SwiperSlide>
          </Swiper>
        </div>
      </Slide>
    </Fragment>
  );
};

export default Categories;
